import {
  useVisaApplicationList,
  useVisaApplicationGetFilters,
} from '../../visa-applications/hooks/use-visa-application.hook';
import type { UseListParams } from '../../../../../types/pagination.types';

// Reuse visa application hooks since we're using the same API
export const useUserSearchList = (params: UseListParams, queryOptions?: any) => {
  return useVisaApplicationList(params, queryOptions);
};

export const useUserSearchGetFilters = (queryOptions?: any) => {
  return useVisaApplicationGetFilters(queryOptions);
};
